import React from 'react';
import { Flex } from '../../components';

import { FAQ, Features, Footer, Header, Navbar, Sitelist, Waitlist } from './sections';

const Home = () => (
  <>
    <Navbar />
    <Flex h="150px" />
    <Header />
    <Flex h="220px" />
    <Features />
    <Flex h="220px" />
    <Sitelist />
    <Flex h="220px" />
    <FAQ />
    <Flex h="220px" />
    <Footer />
  </>
);

export default Home;
